import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import { MenuButton as HeadlessMenuButton } from '@headlessui/react';
import { useMenuButtonStyles } from './MenuButton.Styles';
export const MenuButton = ({ children, className, styled = true, ...props }) => {
    const theme = useTheme();
    const styles = useMenuButtonStyles({
        ...{},
        theme
    });
    return (_jsx(HeadlessMenuButton, { className: `${className} ${styled ? styles.button : undefined}`, ...props, children: children }));
};
